import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithErrorHandling } from './baseQuery';

export interface InitiateRCCallRequest {
  to_number: string;
  task_id?: string;
  check_in_id?: string;
  check_in_v2_id?: string;
}

export interface InitiateRCCallResponse {
  call_uri: string;
}

export interface RCOAuthStatus {
  connected: boolean;
  extension_name?: string;
  extension_number?: string;
}

export const ringcentralApi = createApi({
  reducerPath: 'ringcentralApi',
  baseQuery: baseQueryWithErrorHandling,
  tagTypes: ['RCOAuthStatus'],
  endpoints: (builder) => ({
    initiateRCCall: builder.mutation<
      InitiateRCCallResponse,
      { matterId: string } & InitiateRCCallRequest
    >({
      query: ({ matterId, ...body }) => ({
        url: `api/matters/${matterId}/ringcentral/initiate_call/`,
        method: 'POST',
        body,
      }),
    }),

    getRCCallArtifact: builder.query<
      {
        call_id: string;
        conversation_id?: string | null;
        ringcentral_call_pk?: string | null;
        ringcentral_user_name?: string | null;
        artifact_id?: string | null;
        matter_id?: string | null;
      },
      { callId: string; fromNumber?: string }
    >({
      query: ({ callId, fromNumber }) => ({
        url: `api/integrations/ringcentral/call/${encodeURIComponent(callId)}/artifact/${fromNumber ? `?from_number=${encodeURIComponent(fromNumber)}` : ''}`,
        method: 'GET',
      }),
    }),

    getRCOAuthStatus: builder.query<RCOAuthStatus, void>({
      query: () => 'api/integrations/ringcentral/oauth/status',
      providesTags: ['RCOAuthStatus'],
    }),

    disconnectRCOAuth: builder.mutation<{ message: string }, void>({
      query: () => ({
        url: 'api/integrations/ringcentral/oauth/disconnect',
        method: 'POST',
      }),
      invalidatesTags: ['RCOAuthStatus'],
    }),
  }),
});

export const {
  useInitiateRCCallMutation,
  useGetRCCallArtifactQuery,
  useLazyGetRCCallArtifactQuery,
  useGetRCOAuthStatusQuery,
  useDisconnectRCOAuthMutation,
} = ringcentralApi;
